import React from "react";
import { FormRender, FormRequest, getQueryParam, parseBoolean } from "../form-client";

export default function Landing() {
	const fp: FormRequest = {
		EventID: getQueryParam("event_id"),
		Events2DoId: getQueryParam("events2do_id"),
		FormHeaderId: getQueryParam("form_header_id"),
		KeyValue: getQueryParam("key_value"),
		isCompleteScheduledEvent:
			parseBoolean(getQueryParam("is_complete_sched_event")) || parseBoolean(getQueryParam("completeSchedEvent")),
		ParentValue: getQueryParam("parent_value"),
		FormMode: getQueryParam("form_mode"),
		ProgramPS: getQueryParam("programPS"),
		SitePS: getQueryParam("sitePS"),
		ProgramEnrollment: getQueryParam("peID") || getQueryParam("programEnrollment"),
		IsAddAllowed: true,
		IsEditAllowed: true,
		ServiceTrack: getQueryParam("serviceTrack"),
	};

	return (
		<div style={{ paddingTop: "15px", height: "100%" }}>
			<FormRender req={fp} isSubForm={false} />
		</div>
	);
}
